import hrtime from 'browser-process-hrtime';

// @ts-ignore
process.hrtime = hrtime;

export * from './measureTime';
